import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState, useRef } from "react";
import DataTable from "../../../../Common/DataTable/DataTable";
import DataTableHeader from "../../../../Common/DataTableHeader/DataTableHeader";
import DataTableFooter from "../../../../Common/DataTableFooter/DataTableFooter";
import { useNavigate } from "react-router-dom";
import { staffListColumns } from "./StaffListColumns";
import { GET_ALL_STAFF_LIST_REQUEST } from "../../../../Utils/Constant";

const StaffListTable = ({ setSelectedCategory }) => {
  const dispatch = useDispatch();

  const [categoryData, setCategoryData] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(1);
  const [sortBy, setSortBy] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const [globalFilter, setGlobalFilter] = useState("");
  const [gloablFilterType, setGloablFilterType] = useState("name");
  const [openMenuId, setOpenMenuId] = useState(null);
  const navigate = useNavigate();

  const { staffList, loading } = useSelector((state) => state.settings);

  useEffect(() => {
    dispatch({
      type: GET_ALL_STAFF_LIST_REQUEST,
      payload: { page, limit: pageSize, sortBy, sortOrder, name: globalFilter },
    });
  }, [dispatch, page, pageSize, sortBy, sortOrder, globalFilter]);

  const handleManageAccessClick= (data)=>
  {
    navigate(`${data?.id}`,{state:data})
  }

  useEffect(() => {
    if (staffList?.data?.length) {
      const transformed = staffList?.data?.map((data) => ({
        name: data?.first_name + data?.last_name || "N/A",
        role: data?.role || "N/A",
        actions: (
          <>
            <button
              className="btn text-decoration-underline
"
              onClick={() => handleManageAccessClick(data)}
            >
              Manage Access
            </button>
          </>
        ),
      }));

      setCategoryData(transformed);
    } else {
      setCategoryData([]);
    }
  }, [openMenuId, staffList , loading]);

  const handleSortChange = (sort) => {
    setSortBy(sort.id);
    setSortOrder(sort.desc ? "desc" : "asc");
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  // Extract total entries and total pages from API pagination info
  const totalEntries = staffList?.pagination?.totalResults || 0;
  const totalPages = staffList?.pagination?.totalPages || 1;

  return (
    <div>
      <DataTableHeader
        pageSize={pageSize}
        setPageSize={setPageSize}
        globalFilter={globalFilter}
        setGlobalFilter={setGlobalFilter}
        setCurrentPage={setPage}
        gloablFilterType={gloablFilterType}
        setGloablFilterType={setGloablFilterType}
        flage="settings"
      />
      <DataTable
        columns={staffListColumns}
        data={categoryData}
        pageSize={pageSize}
        setPageSize={setPageSize}
        onSortChange={handleSortChange}
        isLoading={loading}
      />
      <DataTableFooter
        currentPage={page}
        totalPages={totalPages}
        setCurrentPage={handlePageChange}
        totalEntries={totalEntries}
        pageSize={pageSize}
      />
    </div>
  );
};

export default StaffListTable;
